import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import CustomerReport from "./TaxExemptReport";

export default function Reports() {
  /*   All States
   ********************************************* */
  // Search Urls
  const [searchParams, setSearchParams] = useSearchParams();

  const [activeTab, setActiveTab] = useState("taxExemptReport");

  /*   All Functions
   ********************************************* */
  // function to handle tab change
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSearchParams({ tab });
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    const tab = searchParams.get("tab") || "taxExemptReport";
    setSearchParams({ tab });
    setActiveTab(tab);
  }, []);

  return (
    <div
      className={`flex-grow-1 h-100`}
      style={{
        position: "fixed",
        overflow: "auto",
        top: 0,
        width: "calc(100vw - 260px)",
        marginLeft: 260,
        zIndex: "99",
      }}
    >
      {/* Top Navigation */}
      <div className="bg-white shadow-sm py-2 w-100 px-2 d-flex align-items-center justify-content-start">
        <button
          onClick={() => handleTabChange("taxExemptReport")}
          className={`btn ${activeTab === "taxExemptReport" && "btn-primary"}`}
        >
          Tax Exempt Report
        </button>
        <div
          className={`btn ${activeTab === "others" && "btn-primary"}`}
          onClick={() => handleTabChange("others")}
        >
          Other Reports
        </div>
      </div>
      {/* Tab Content */}
      <div className="py-3 px-2 ">
        {activeTab === "taxExemptReport" && <CustomerReport />}
        {activeTab === "others" && (
          <div className="h-100 d-flex align-items-center justify-content-center">
            <h1>Coming soon ... </h1>
          </div>
        )}
      </div>
    </div>
  );
}
